/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable consistent-return */
/* eslint-disable default-case */
/* eslint-disable react/function-component-definition */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { ReactElement, useEffect, useState } from "react";

import "./TransitsTableForm.css";

import { Button } from "react-bulma-components";
import styled from "styled-components";

import { EditMode, EDIT_MODE } from "components/NewRouteDialog/NewRouteDialog";
import { CommuterPassCheckBox } from "components/TransitsTableForm/CommuterPassCheckBox";
import { FareRow } from "components/TransitsTableForm/FareRow";
import {
  getTransportationTypeName,
  TRANSPORTATION_TYPE,
  TRANSPORTATION_TYPE_NAME,
} from "enums/transportationType";
import { getDistanceKmString } from "helpers/distance";
import { convertHomeString } from "helpers/label";
import { RESPONSIVE } from "helpers/responsive";
import { validateDistance } from "helpers/validator";
import { useCandidateRoutes } from "hooks/candicate_routes";
import {
  SuggestedPreparedRoute,
  SuggestedPreparedRouteDetail,
} from "models/suggestedPreparedRoute";
import * as Table from "molecules/Table";

const showAddressName = (name?: string) => (
  <span>{convertHomeString(name)}</span>
);

export const TransitsTableFormInput = styled.input`
  width: 50px;

  @media ${RESPONSIVE.DESKTOP} {
    width: 95px;
  }
`;

export const TransitsTableFormInputUnit = styled.span`
  line-height: 1.1rem;
  padding-left: 0.3rem;

  @media ${RESPONSIVE.DESKTOP} {
    line-height: 2.4rem;
    padding-left: 0.6rem;
  }
`;

export interface TransitsTableFormProps {
  isCreateInProgress: boolean;
  suggestedPreparedRouteIndex?: number;
  suggestedPreparedRoute?: SuggestedPreparedRoute;
  editMode?: EditMode;
  createPreparedRoute?: (
    suggestedPreparedRoute: SuggestedPreparedRoute
  ) => void;
  changeTransportationType: (mode: any) => void;
}

const convertTransportationMode = (mode: any) => {
  switch (mode) {
    case TRANSPORTATION_TYPE.walk:
      return "walk";
    case TRANSPORTATION_TYPE.my_car:
      return "car";
    case TRANSPORTATION_TYPE.bicycle:
      return "bicycle";
    case TRANSPORTATION_TYPE.train:
    case TRANSPORTATION_TYPE.bus:
    case TRANSPORTATION_TYPE.other:
      return undefined;
  }
};

export const TransitsTableForm: React.FC<TransitsTableFormProps> = ({
  isCreateInProgress,
  suggestedPreparedRouteIndex,
  suggestedPreparedRoute,
  editMode,
  createPreparedRoute,
  changeTransportationType,
}) => {
  if (
    isCreateInProgress !== undefined &&
    suggestedPreparedRouteIndex !== undefined &&
    suggestedPreparedRoute &&
    editMode &&
    createPreparedRoute &&
    changeTransportationType
  ) {
    return (
      <SuggestedPreparedRouteDetails
        isCreateInProgress={isCreateInProgress}
        suggestedPreparedRouteIndex={suggestedPreparedRouteIndex}
        suggestedPreparedRoute={suggestedPreparedRoute}
        editMode={editMode}
        createPreparedRoute={createPreparedRoute}
        changeTransportationType={changeTransportationType}
      />
    );
  }

  return null;
};

const SuggestedPreparedRouteDetails: React.FC<{
  isCreateInProgress: boolean;
  suggestedPreparedRouteIndex: number;
  suggestedPreparedRoute: SuggestedPreparedRoute;
  editMode: EditMode;
  createPreparedRoute: (suggestedPreparedRoute: SuggestedPreparedRoute) => void;
  changeTransportationType: (mode: any) => void;
}> = ({
  isCreateInProgress,
  suggestedPreparedRouteIndex,
  suggestedPreparedRoute,
  editMode,
  createPreparedRoute,
  changeTransportationType,
}) => {
  switch (editMode) {
    case EDIT_MODE.PUBLIC_TRANSPORTATION:
      return (
        <SuggestedPreparedRouteDetailsInPublicTransportationMode
          isCreateInProgress={isCreateInProgress}
          suggestedPreparedRouteIndex={suggestedPreparedRouteIndex}
          suggestedPreparedRoute={suggestedPreparedRoute}
          createPreparedRoute={createPreparedRoute}
          changeTransportationMode={changeTransportationType}
        />
      );
    case EDIT_MODE.CAR_AND_BICYCLE:
      return (
        <SuggestedPreparedRouteDetailsInCarAndBicycleMode
          isCreateInProgress={isCreateInProgress}
          suggestedPreparedRouteIndex={suggestedPreparedRouteIndex}
          suggestedPreparedRoute={suggestedPreparedRoute}
          createPreparedRoute={createPreparedRoute}
          changeTransportationMode={changeTransportationType}
        />
      );
    default:
      return (
        <SuggestedPreparedRouteDetailsInManualMode
          isCreateInProgress={isCreateInProgress}
          suggestedPreparedRouteIndex={suggestedPreparedRouteIndex}
          suggestedPreparedRoute={suggestedPreparedRoute}
          createPreparedRoute={createPreparedRoute}
          changeTransportationMode={changeTransportationType}
        />
      );
  }
};

const validateTransportationTypeAndFare = (
  transportationType?: number,
  fare?: number
): boolean =>
  transportationType === 0 &&
  !(fare === undefined || fare === null || fare === 0);

const SuggestedPreparedRouteDetailsInPublicTransportationMode: React.FC<{
  isCreateInProgress: boolean;
  suggestedPreparedRouteIndex: number;
  suggestedPreparedRoute: SuggestedPreparedRoute;
  createPreparedRoute: (suggestedPreparedRoute: SuggestedPreparedRoute) => void;
  // eslint-disable-next-line react/no-unused-prop-types
  changeTransportationMode: (mode: any) => void;
}> = ({
  isCreateInProgress,
  suggestedPreparedRouteIndex,
  suggestedPreparedRoute,
  createPreparedRoute,
}) => {
  const [route, setRoute] = useState<SuggestedPreparedRoute>(
    suggestedPreparedRoute
  );
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [distanceRoutes, , setFetchCondition] = useCandidateRoutes();
  const [registerable, setRegisterable] = useState<boolean>(false);

  useEffect(() => {
    if (distanceRoutes) {
      if (distanceRoutes.length > 0) {
        // // TODO: これでええんか？感
        route.suggestedPreparedRouteDetails[0].distanceKm =
          distanceRoutes[0].suggestedPreparedRouteDetails[0].distanceKm;
        setRoute({ ...route });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [distanceRoutes]);

  const changeFare = (_: number, fare?: number) => {
    setRegisterable(
      validateTransportationTypeAndFare(
        route.suggestedPreparedRouteDetails[0].transportationType,
        fare
      )
    );

    route.suggestedPreparedRouteDetails[0].fare = fare;
    route.totalFare = route.suggestedPreparedRouteDetails.reduce(
      (acc: number, detail) => acc + detail.fare!,
      0
    );
    setRoute({ ...route });
  };

  const changeTransportationType = (_: number, transportationType?: number) => {
    setRegisterable(
      validateTransportationTypeAndFare(
        transportationType,
        route.suggestedPreparedRouteDetails[0].fare
      )
    );

    route.suggestedPreparedRouteDetails[0].transportationType =
      transportationType;
    if (
      route.suggestedPreparedRouteDetails[0].departureId &&
      route.suggestedPreparedRouteDetails[0].arrivalId
    ) {
      setFetchCondition({
        departureId: route.suggestedPreparedRouteDetails[0].departureId,
        arrivalId: route.suggestedPreparedRouteDetails[0].arrivalId,
        mode: convertTransportationMode(transportationType),
      });
    }
    setRoute({ ...route });
  };

  const changeUseCommuterPass = (
    _: number,
    index: number,
    useCommuterPass: boolean
  ) => {
    route.suggestedPreparedRouteDetails[index].useCommuterPass =
      useCommuterPass;
    setRoute({ ...route });
  };

  return (
    <>
      <div className="cw-transits-table-overview">
        <div className="cw-transits-table-overview-title">
          <h4 className="title is-4">
            経路候補 {suggestedPreparedRouteIndex + 1}
            {registerable && (
              <span className="subtitle is-size-6 pl-4 has-text-danger">
                徒歩区間に金額が入力されています
              </span>
            )}
          </h4>
        </div>

        <Button
          color="primary"
          disabled={isCreateInProgress || registerable}
          onClick={() => createPreparedRoute(route)}
        >
          選択
        </Button>
      </div>
      <Table.Table>
        <thead>
          <tr>
            <Table.ThMedium>交通手段</Table.ThMedium>
            <Table.Th>路線名</Table.Th>
            <Table.Th>出発地</Table.Th>
            <Table.Th>到着地</Table.Th>
            <Table.ThSmall>移動距離</Table.ThSmall>
            <Table.ThMedium>金額</Table.ThMedium>
            <Table.ThUseCommuterPass>定期</Table.ThUseCommuterPass>
          </tr>
        </thead>
        <tbody>
          {route.suggestedPreparedRouteDetails.map(
            (suggestedPreparedRouteDetail, index) => (
              <tr key={suggestedPreparedRouteDetail.orderNo}>
                <Table.Td>
                  {index === 0 &&
                    renderTransportationType(
                      EDIT_MODE.PUBLIC_TRANSPORTATION,
                      changeTransportationType,
                      suggestedPreparedRouteIndex,
                      suggestedPreparedRouteDetail.transportationType
                    )}
                  {index > 0 &&
                    suggestedPreparedRouteDetail.transportationTypeName}
                </Table.Td>
                <Table.Td>{suggestedPreparedRouteDetail.lineName}</Table.Td>
                <Table.Td>
                  {showAddressName(suggestedPreparedRouteDetail.departureName)}
                </Table.Td>
                <Table.Td>
                  {showAddressName(suggestedPreparedRouteDetail.arrivalName)}
                </Table.Td>
                <Table.Td>
                  {getDistanceKmString(suggestedPreparedRouteDetail.distanceKm)}
                </Table.Td>
                <Table.Td>
                  <FareRow
                    editMode={EDIT_MODE.PUBLIC_TRANSPORTATION}
                    suggestedPreparedRouteIndex={suggestedPreparedRouteIndex}
                    suggestedPreparedRouteDetail={suggestedPreparedRouteDetail}
                    preparedRouteDetailIndex={index}
                    changeFare={changeFare}
                  />
                </Table.Td>
                <Table.TdUseCommuterPass>
                  <CommuterPassCheckBox
                    suggestedPreparedRouteIndex={suggestedPreparedRouteIndex}
                    suggestedPreparedRouteDetail={suggestedPreparedRouteDetail}
                    preparedRouteDetailIndex={index}
                    changeUseCommuterPass={changeUseCommuterPass}
                  />
                </Table.TdUseCommuterPass>
              </tr>
            )
          )}
        </tbody>
      </Table.Table>
    </>
  );
};

const SuggestedPreparedRouteDetailsInCarAndBicycleMode: React.FC<{
  isCreateInProgress: boolean;
  suggestedPreparedRouteIndex: number;
  suggestedPreparedRoute: SuggestedPreparedRoute;
  createPreparedRoute: (suggestedPreparedRoute: SuggestedPreparedRoute) => void;
  changeTransportationMode: (mode: any) => void;
}> = ({
  isCreateInProgress,
  suggestedPreparedRouteIndex,
  suggestedPreparedRoute,
  createPreparedRoute,
  changeTransportationMode,
}) => {
  const [route, setRoute] = useState<SuggestedPreparedRoute>(
    suggestedPreparedRoute
  );
  const [registerable, setRegisterable] = useState<boolean>(false);

  const changeFare = (_: number, fare?: number) => {
    setRegisterable(
      validateTransportationTypeAndFare(
        route.suggestedPreparedRouteDetails[0].transportationType,
        fare
      )
    );

    route.suggestedPreparedRouteDetails[0].fare = fare;
    route.totalFare = fare;
    setRoute({ ...route });
  };

  const changeDistance = (distance?: number) => {
    route.suggestedPreparedRouteDetails[0].distanceKm = distance;
    route.totalDistanceKm = distance;
    setRoute({ ...route });
  };

  const changeTransportationType = (_: number, transportationType?: number) => {
    setRegisterable(
      validateTransportationTypeAndFare(
        transportationType,
        route.suggestedPreparedRouteDetails[0].fare
      )
    );

    route.suggestedPreparedRouteDetails[0].transportationType =
      transportationType;
    changeTransportationMode(convertTransportationMode(transportationType));
    setRoute({ ...route });
  };

  const changeUseCommuterPass = (
    _: number,
    index: number,
    useCommuterPass: boolean
  ) => {
    route.suggestedPreparedRouteDetails[index].useCommuterPass =
      useCommuterPass;
    setRoute({ ...route });
  };

  const { suggestedPreparedRouteDetails } = route;

  return (
    <>
      <div className="cw-transits-table-overview">
        <div className="cw-transits-table-overview-title">
          <h4 className="title is-4">
            経路候補
            {registerable && (
              <span className="subtitle is-size-6 pl-4 has-text-danger">
                徒歩区間に金額が入力されています
              </span>
            )}
          </h4>
        </div>
        <div className="cw-transits-table-overview-actions">
          <button
            type="button"
            disabled={isCreateInProgress || registerable}
            className="button is-primary"
            onClick={(_event) => createPreparedRoute(route)}
          >
            選択
          </button>
        </div>
      </div>
      <Table.Table>
        <thead>
          <tr>
            <Table.ThMedium>交通手段</Table.ThMedium>
            <Table.Th>出発地</Table.Th>
            <Table.Th>到着地</Table.Th>
            <Table.ThMedium>移動距離</Table.ThMedium>
            <Table.ThMedium>金額</Table.ThMedium>
            <Table.ThUseCommuterPass>定期</Table.ThUseCommuterPass>
          </tr>
        </thead>
        <tbody>
          {suggestedPreparedRouteDetails.map(
            (suggestedPreparedRouteDetail, index) => {
              const isLast = index === suggestedPreparedRouteDetails.length - 1;
              return (
                <tr key={suggestedPreparedRouteDetail.orderNo}>
                  <Table.Td>
                    {renderTransportationType(
                      EDIT_MODE.CAR_AND_BICYCLE,
                      changeTransportationType,
                      index,
                      suggestedPreparedRouteDetail.transportationType,
                      isLast
                    )}
                  </Table.Td>
                  <Table.Td>
                    {showAddressName(
                      suggestedPreparedRouteDetail.departureName
                    )}
                  </Table.Td>
                  <Table.Td>
                    {showAddressName(suggestedPreparedRouteDetail.arrivalName)}
                  </Table.Td>
                  <Table.Td>
                    <TransitsTableFormInput
                      className="input"
                      type="number"
                      value={
                        Number.isFinite(
                          suggestedPreparedRouteDetail.distanceKm!
                        )
                          ? suggestedPreparedRouteDetail.distanceKm
                          : ""
                      }
                      onChange={(event) => {
                        const distance = parseFloat(event.target.value);
                        if (validateDistance(distance)) {
                          changeDistance(distance);
                        } else {
                          changeDistance();
                        }
                      }}
                    />
                    <TransitsTableFormInputUnit>km</TransitsTableFormInputUnit>
                  </Table.Td>
                  <Table.Td>
                    <FareRow
                      editMode={EDIT_MODE.CAR_AND_BICYCLE}
                      suggestedPreparedRouteIndex={suggestedPreparedRouteIndex}
                      suggestedPreparedRouteDetail={
                        suggestedPreparedRouteDetail
                      }
                      preparedRouteDetailIndex={index}
                      changeFare={changeFare}
                    />
                  </Table.Td>
                  <Table.TdUseCommuterPass>
                    <CommuterPassCheckBox
                      suggestedPreparedRouteIndex={suggestedPreparedRouteIndex}
                      suggestedPreparedRouteDetail={
                        suggestedPreparedRouteDetail
                      }
                      preparedRouteDetailIndex={index}
                      changeUseCommuterPass={changeUseCommuterPass}
                    />
                  </Table.TdUseCommuterPass>
                </tr>
              );
            }
          )}
        </tbody>
      </Table.Table>
    </>
  );
};

const renderTransportationType = (
  editMode: EditMode,
  changeTransportationType: (
    suggestedPreparedRouteIndex: number,
    transportationType?: number
  ) => void,
  suggestedPreparedRouteIndex: number,
  selectedTransportationType?: number,
  isLast = false
) => {
  const options = [];
  if (
    editMode === EDIT_MODE.PUBLIC_TRANSPORTATION ||
    editMode === EDIT_MODE.CAR_AND_BICYCLE ||
    (editMode === EDIT_MODE.MANUAL &&
      (suggestedPreparedRouteIndex === 0 || isLast))
  ) {
    options.push(
      <option key={TRANSPORTATION_TYPE.walk} value={TRANSPORTATION_TYPE.walk}>
        {TRANSPORTATION_TYPE_NAME.walk}
      </option>
    );
    options.push(
      <option
        key={TRANSPORTATION_TYPE.bicycle}
        value={TRANSPORTATION_TYPE.bicycle}
      >
        {TRANSPORTATION_TYPE_NAME.bicycle}
      </option>
    );
    options.push(
      <option
        key={TRANSPORTATION_TYPE.my_car}
        value={TRANSPORTATION_TYPE.my_car}
      >
        {TRANSPORTATION_TYPE_NAME.my_car}
      </option>
    );
  } else if (editMode === EDIT_MODE.MANUAL) {
    // eslint-disable-next-line no-restricted-syntax
    for (const [key, value] of Object.entries(TRANSPORTATION_TYPE)) {
      options.push(
        <option key={value} value={value}>
          {getTransportationTypeName(key)!}
        </option>
      );
    }
  }

  return (
    <div className="select">
      <select
        value={selectedTransportationType}
        onChange={(event) => {
          if (event.target.selectedOptions[0].value) {
            changeTransportationType(
              suggestedPreparedRouteIndex,
              parseInt(event.target.selectedOptions[0].value, 10)
            );
          } else {
            changeTransportationType(suggestedPreparedRouteIndex, undefined);
          }
        }}
      >
        {options}
      </select>
    </div>
  );
};

interface SuggestedPreparedRouteDetailsInManualModeProps {
  isCreateInProgress: boolean;
  suggestedPreparedRouteIndex: number;
  suggestedPreparedRoute: SuggestedPreparedRoute;
  createPreparedRoute: (suggestedPreparedRoute: SuggestedPreparedRoute) => void;
  // eslint-disable-next-line react/no-unused-prop-types
  changeTransportationMode: (mode: any) => void;
}

function SuggestedPreparedRouteDetailsInManualMode({
  isCreateInProgress,
  suggestedPreparedRouteIndex,
  suggestedPreparedRoute,
  createPreparedRoute,
}: SuggestedPreparedRouteDetailsInManualModeProps): ReactElement | null {
  const [route, setRoute] = useState<SuggestedPreparedRoute>(
    suggestedPreparedRoute
  );
  const [registerable, setRegisterable] = useState<boolean>(false);

  const changeFare = (index: number, fare?: number) => {
    setRegisterable(
      validateTransportationTypeAndFare(
        route.suggestedPreparedRouteDetails[index].transportationType,
        fare
      )
    );

    route.suggestedPreparedRouteDetails[index].fare = fare;
    route.totalFare = route.suggestedPreparedRouteDetails.reduce(
      (acc: number, detail) => acc + detail.fare!,
      0
    );
    setRoute({ ...route });
  };

  const changeDistance = (index: number, distance?: number) => {
    route.suggestedPreparedRouteDetails[index].distanceKm = distance;
    route.totalDistanceKm = route.suggestedPreparedRouteDetails.reduce(
      (acc: number, detail) => acc + detail.distanceKm!,
      0
    );
    setRoute({ ...route });
  };

  const changeTransportationType = (
    index: number,
    transportationType?: number
  ) => {
    setRegisterable(
      validateTransportationTypeAndFare(
        transportationType,
        route.suggestedPreparedRouteDetails[index].fare
      )
    );

    route.suggestedPreparedRouteDetails[index].transportationType =
      transportationType;
    setRoute({ ...route });
  };

  const changeArrivalName = (name: string, index: number) => {
    route.suggestedPreparedRouteDetails[index].arrivalName = name;
    route.suggestedPreparedRouteDetails[index + 1].departureName = name;
    setRoute({ ...route });
  };

  const changeUseCommuterPass = (
    _: number,
    index: number,
    useCommuterPass: boolean
  ) => {
    route.suggestedPreparedRouteDetails[index].useCommuterPass =
      useCommuterPass;
    setRoute({ ...route });
  };

  const renderDepartureName = (index: number, name: string) => {
    if (index === 0) {
      return showAddressName(name);
    }
    return <span>{name}</span>;
  };

  const renderArrivalName = (index: number, isLast: boolean, name: string) => {
    if (!isLast) {
      return (
        <input
          className="input"
          type="text"
          value={name || ""}
          onChange={(event) => {
            changeArrivalName(event.target.value, index);
          }}
        />
      );
    }
    return showAddressName(name);
  };

  const renderAddButton = (index: number, length: number, isLast: boolean) =>
    // 最後の行には追加ボタン出さない
    (length === 1 || !isLast) && (
      <Button color="primary" onClick={() => addPreparedRoute(index)}>
        <i className="fa fa-xs fa-plus" />
      </Button>
    );

  const renderDelButton = (index: number, length: number, isLast: boolean) =>
    isRenderDelButton(index, length, isLast) && (
      <Button color="danger" onClick={() => delPreparedRoute(index)}>
        <i className="fa fa-xs fa-times" />
      </Button>
    );

  const isRenderDelButton = (
    index: number,
    length: number,
    isLast: boolean
  ) => {
    // 1行の場合は出さない
    if (length === 1) {
      return false;
    }

    // 2行の場合、2行目にだけ削除ボタンを出す
    if (length === 2 && index === 1) {
      return true;
    }

    // 1行目と最終行には出さない
    if (index === 0 || isLast) {
      return false;
    }

    return true;
  };

  const reassignOrderNo = (
    preparedRouteDetails: SuggestedPreparedRouteDetail[]
  ) =>
    preparedRouteDetails.map((detail, index) => {
      // eslint-disable-next-line no-param-reassign
      detail.orderNo = index;
      return detail;
    });

  const getMaxOrderNo = (
    preparedRouteDetails: SuggestedPreparedRouteDetail[]
  ) =>
    Math.max.apply(
      null,
      preparedRouteDetails.map((p) => p.orderNo)
    );

  const defaultPreparedRoutesForManual = () => ({
    arrivalId: undefined,
    arrivalName: "",
    departureId: undefined,
    departureName: "",
    distance: 0,
    distanceKm: 0,
    fare: 0,
    initialUseCommuterPass: false,
    lineId: "",
    lineName: "",
    orderNo: getMaxOrderNo(route.suggestedPreparedRouteDetails),
    time: 0,
    transportationType: 3,
    transportationTypeName: "マイカー",
    useCommuterPass: false,
  });

  const addPreparedRoute = (index: number) => {
    const newRoute: SuggestedPreparedRouteDetail =
      defaultPreparedRoutesForManual();

    if (route.suggestedPreparedRouteDetails.length === 1) {
      // 通常、自宅⇒駅⇒駅⇒店舗の形なので最初は2行追加するようにする
      const addRoute: SuggestedPreparedRouteDetail =
        defaultPreparedRoutesForManual();
      route.suggestedPreparedRouteDetails.splice(1, 0, addRoute);

      // 新しい行に到着地を移す
      newRoute.arrivalId = route.suggestedPreparedRouteDetails[0].arrivalId;
      newRoute.arrivalName = route.suggestedPreparedRouteDetails[0].arrivalName;

      route.suggestedPreparedRouteDetails[0].arrivalId = undefined;
      route.suggestedPreparedRouteDetails[0].arrivalName = "";

      // 追加
      newRoute.orderNo = addRoute.orderNo + 1;
      route.suggestedPreparedRouteDetails.splice(2, 0, newRoute);
    } else {
      // 前の行の到着地を新しい行の出発地に引き継ぐ
      newRoute.departureName =
        route.suggestedPreparedRouteDetails[index].arrivalName;

      // 次の行の出発地を空にする
      if (route.suggestedPreparedRouteDetails.length >= 2) {
        route.suggestedPreparedRouteDetails[index + 1].departureName = "";
      }

      // 追加
      route.suggestedPreparedRouteDetails.splice(index + 1, 0, newRoute);
    }

    route.suggestedPreparedRouteDetails = reassignOrderNo(
      route.suggestedPreparedRouteDetails
    );
    setRoute({ ...route });
  };

  const delPreparedRoute = (index: number) => {
    // 2行の場合は、到着地を1行目に移す
    if (route.suggestedPreparedRouteDetails.length === 2) {
      route.suggestedPreparedRouteDetails[0].arrivalId =
        route.suggestedPreparedRouteDetails[1].arrivalId;
      route.suggestedPreparedRouteDetails[0].arrivalName =
        route.suggestedPreparedRouteDetails[1].arrivalName;
    }

    // 次の行の出発地を前の行の到着地にする
    if (route.suggestedPreparedRouteDetails.length >= 3) {
      route.suggestedPreparedRouteDetails[index + 1].departureName =
        route.suggestedPreparedRouteDetails[index - 1].arrivalName;
    }

    // 削除
    route.suggestedPreparedRouteDetails.splice(index, 1);

    // 合計の再計算
    route.totalFare = route.suggestedPreparedRouteDetails.reduce(
      (acc: number, detail) => acc + detail.fare!,
      0
    );
    route.totalDistanceKm = route.suggestedPreparedRouteDetails.reduce(
      (acc: number, detail) => acc + detail.distanceKm!,
      0
    );

    route.suggestedPreparedRouteDetails = reassignOrderNo(
      route.suggestedPreparedRouteDetails
    );
    setRoute({ ...route });
  };

  const handleCreate = (_route: SuggestedPreparedRoute) => {
    // eslint-disable-next-line no-param-reassign
    _route.suggestedPreparedRouteDetails = reassignOrderNo(
      _route.suggestedPreparedRouteDetails
    );
    createPreparedRoute(_route);
  };

  const validatePreparedRoute = () =>
    route.suggestedPreparedRouteDetails.every(
      (detail) => detail.arrivalName !== ""
    );

  const { suggestedPreparedRouteDetails } = route;

  return (
    <>
      <div className="cw-transits-table-overview">
        <div className="cw-transits-table-overview-title">
          <h4 className="title is-4">
            経路候補
            {registerable && (
              <span className="subtitle is-size-6 pl-4 has-text-danger">
                徒歩区間に金額が入力されています
              </span>
            )}
          </h4>
        </div>
        <div className="cw-transits-table-overview-actions">
          <button
            type="button"
            disabled={
              isCreateInProgress || !validatePreparedRoute() || registerable
            }
            className="button is-primary"
            onClick={(_event) => handleCreate(route)}
          >
            選択
          </button>
        </div>
      </div>
      <Table.Table>
        <thead>
          <tr>
            <Table.ThMedium>交通手段</Table.ThMedium>
            <Table.Th>出発地</Table.Th>
            <Table.Th>到着地</Table.Th>
            <Table.ThMedium>移動距離</Table.ThMedium>
            <Table.ThMedium>金額</Table.ThMedium>
            <Table.ThUseCommuterPass>定期</Table.ThUseCommuterPass>
            <Table.ThSmall />
          </tr>
        </thead>
        <tbody>
          {suggestedPreparedRouteDetails.map(
            (suggestedPreparedRouteDetail, index) => {
              const isLast = index === suggestedPreparedRouteDetails.length - 1;
              return (
                <tr key={suggestedPreparedRouteDetail.orderNo}>
                  <Table.Td>
                    {renderTransportationType(
                      EDIT_MODE.MANUAL,
                      changeTransportationType,
                      index,
                      suggestedPreparedRouteDetail.transportationType,
                      isLast
                    )}
                  </Table.Td>
                  <Table.Td>
                    {renderDepartureName(
                      index,
                      suggestedPreparedRouteDetail.departureName
                    )}
                  </Table.Td>
                  <Table.Td>
                    {renderArrivalName(
                      index,
                      isLast,
                      suggestedPreparedRouteDetail.arrivalName
                    )}
                  </Table.Td>
                  <Table.Td>
                    <TransitsTableFormInput
                      className="input"
                      type="number"
                      value={
                        Number.isFinite(
                          suggestedPreparedRouteDetail.distanceKm!
                        )
                          ? suggestedPreparedRouteDetail.distanceKm
                          : ""
                      }
                      onChange={(event) => {
                        const distance = parseFloat(event.target.value);
                        if (validateDistance(distance)) {
                          changeDistance(index, distance);
                        } else {
                          changeDistance(index);
                        }
                      }}
                    />
                    <TransitsTableFormInputUnit>km</TransitsTableFormInputUnit>
                  </Table.Td>
                  <Table.Td>
                    <FareRow
                      editMode={EDIT_MODE.MANUAL}
                      suggestedPreparedRouteIndex={index}
                      suggestedPreparedRouteDetail={
                        suggestedPreparedRouteDetail
                      }
                      preparedRouteDetailIndex={index}
                      changeFare={changeFare}
                    />
                  </Table.Td>
                  <Table.TdUseCommuterPass>
                    <CommuterPassCheckBox
                      suggestedPreparedRouteIndex={suggestedPreparedRouteIndex}
                      suggestedPreparedRouteDetail={
                        suggestedPreparedRouteDetail
                      }
                      preparedRouteDetailIndex={index}
                      changeUseCommuterPass={changeUseCommuterPass}
                    />
                  </Table.TdUseCommuterPass>
                  <Table.Td>
                    {renderAddButton(
                      index,
                      suggestedPreparedRouteDetails.length,
                      isLast
                    )}
                    {renderDelButton(
                      index,
                      suggestedPreparedRouteDetails.length,
                      isLast
                    )}
                  </Table.Td>
                </tr>
              );
            }
          )}
        </tbody>
      </Table.Table>
    </>
  );
}

/* eslint-enable */
